var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
export var isSystemInsideFolder = function (system, folder, allFolders) {
    var e_1, _a;
    if (folder.id === system.folderId) {
        return true;
    }
    var subFolders = allFolders.filter(function (f) { return f.parentId === folder.id; });
    try {
        for (var subFolders_1 = __values(subFolders), subFolders_1_1 = subFolders_1.next(); !subFolders_1_1.done; subFolders_1_1 = subFolders_1.next()) {
            var subFolder = subFolders_1_1.value;
            var isInSubFolder = isSystemInsideFolder(system, subFolder, allFolders);
            if (isInSubFolder) {
                return true;
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (subFolders_1_1 && !subFolders_1_1.done && (_a = subFolders_1.return)) _a.call(subFolders_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return false;
};
export var countSystemsInFolder = function (folder, allFolders, allSystems) {
    var e_2, _a;
    var systemCount = allSystems.filter(function (system) { return system.folderId === folder.id; }).length;
    var subFolders = allFolders.filter(function (f) { return f.parentId === folder.id; });
    try {
        for (var subFolders_2 = __values(subFolders), subFolders_2_1 = subFolders_2.next(); !subFolders_2_1.done; subFolders_2_1 = subFolders_2.next()) {
            var subFolder = subFolders_2_1.value;
            systemCount += countSystemsInFolder(subFolder, allFolders, allSystems);
        }
    }
    catch (e_2_1) { e_2 = { error: e_2_1 }; }
    finally {
        try {
            if (subFolders_2_1 && !subFolders_2_1.done && (_a = subFolders_2.return)) _a.call(subFolders_2);
        }
        finally { if (e_2) throw e_2.error; }
    }
    return systemCount;
};
/**
 * Filters systems whose name contains the given query (case-insensitive,
 * substring match). An empty/whitespace-only query matches nothing, since
 * search results are only shown while the user is actively searching.
 */
export var filterSystemsByName = function (systems, query) {
    var trimmed = query.trim().toLowerCase();
    if (!trimmed) {
        return [];
    }
    return systems.filter(function (system) {
        return system.name.toLowerCase().includes(trimmed);
    });
};
/**
 * The selectable application types, in display order. Keep this in sync with
 * the backend `applicationType` enum (the type above enforces that each entry
 * is valid, but not that all backend values are listed).
 */
export var applicationTypes = [
    "sheetmetal",
    "glass",
    "plastic",
    "cardboard",
];
/**
 * Filters systems by a single application type. Passing `undefined` (the
 * default "all applications" choice) applies no filtering and keeps systems
 * without an application type; otherwise only systems whose application type
 * matches are kept.
 */
export var filterSystemsByApplication = function (systems, selected) {
    if (!selected) {
        return systems;
    }
    return systems.filter(function (system) { return system.applicationType === selected; });
};
/**
 * Builds the folder path of the folder a system lives in, from root to leaf,
 * e.g. "Parent / Child". Systems at the root return the provided root name.
 */
export var getFolderPath = function (folderId, allFolders, rootFolderName) {
    var names = [];
    var currentId = folderId;
    // Guard against cyclic parent references so we never loop forever.
    var visited = new Set();
    while (currentId && !visited.has(currentId)) {
        visited.add(currentId);
        var folder = allFolders.find(function (f) { return f.id === currentId; });
        if (!folder)
            break;
        names.unshift(folder.name);
        currentId = folder.parentId;
    }
    return names.length ? names.join(" / ") : rootFolderName;
};
export var countFoldersInFolder = function (folder, allFolders) {
    var e_3, _a;
    var folderCount = 0;
    var subFolders = allFolders.filter(function (f) { return f.parentId === folder.id; });
    folderCount += subFolders.length;
    try {
        for (var subFolders_3 = __values(subFolders), subFolders_3_1 = subFolders_3.next(); !subFolders_3_1.done; subFolders_3_1 = subFolders_3.next()) {
            var subFolder = subFolders_3_1.value;
            folderCount += countFoldersInFolder(subFolder, allFolders);
        }
    }
    catch (e_3_1) { e_3 = { error: e_3_1 }; }
    finally {
        try {
            if (subFolders_3_1 && !subFolders_3_1.done && (_a = subFolders_3.return)) _a.call(subFolders_3);
        }
        finally { if (e_3) throw e_3.error; }
    }
    return folderCount;
};
var rootDummyId = "root"; // the folder type does not allow undefined as an id so representing the root folder with this id internally in these functions
export var createFolderTree = function (allFolders, rootFolderName, fromFolder) {
    return __assign(__assign({}, (fromFolder || {
        id: rootDummyId,
        parentId: null,
        lastEdited: "",
        name: rootFolderName,
    })), { children: allFolders
            .filter(function (folder) {
            return (!fromFolder && folder.parentId === null) ||
                (fromFolder && folder.parentId === fromFolder.id);
        })
            .map(function (folder) { return createFolderTree(allFolders, rootFolderName, folder); }) });
};
export var flattenFolderTree = function (folderTree, depth) {
    var e_4, _a;
    if (depth === void 0) { depth = 0; }
    var result = [
        {
            id: folderTree.id === rootDummyId ? undefined : folderTree.id,
            label: folderTree.name,
            depth: depth,
        },
    ];
    try {
        for (var _b = __values(folderTree.children), _c = _b.next(); !_c.done; _c = _b.next()) {
            var child = _c.value;
            result.push.apply(result, __spreadArray([], __read(flattenFolderTree(child, depth + 1)), false));
        }
    }
    catch (e_4_1) { e_4 = { error: e_4_1 }; }
    finally {
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        }
        finally { if (e_4) throw e_4.error; }
    }
    return result;
};
export var toFlatMenuOptions = function (folderTree, disableIds, excludeIds) {
    var disabled = disableIds.map(function (id) { return id || rootDummyId; });
    var excluded = excludeIds.map(function (id) { return id || rootDummyId; });
    var flatten = function (tree, depth) {
        var e_5, _a;
        if (excluded.includes(tree.id))
            return [];
        var indent = "\u00A0".repeat(depth * 5);
        var prefix = depth > 0 ? "└ " : "";
        var result = [
            {
                value: tree.id === rootDummyId ? undefined : tree.id,
                label: "".concat(indent).concat(prefix).concat(tree.name),
                disabled: disabled.includes(tree.id),
            },
        ];
        try {
            for (var _b = __values(tree.children), _c = _b.next(); !_c.done; _c = _b.next()) {
                var child = _c.value;
                if (!excluded.includes(child.id)) {
                    result.push.apply(result, __spreadArray([], __read(flatten(child, depth + 1)), false));
                }
            }
        }
        catch (e_5_1) { e_5 = { error: e_5_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_5) throw e_5.error; }
        }
        return result;
    };
    return flatten(folderTree, 0);
};
